<template>
  <div class="auth-layout">
    <HeadBar />
    <main class="auth-main">
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import HeadBar from '@/components/app/HeadBar.vue';
</script>

<style scoped lang="scss">
.auth-layout {
  min-height: var(--app-viewport-height);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.auth-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f5f7ff 100%);
}
</style>
